<div class="progress-bar-overlay" *ngIf="inFlight"></div>
<app-progress-bar [inFlight]="inFlight"></app-progress-bar>
